import React from 'react';
import {Col, Panel, Row} from 'react-bootstrap';
import ArrowButton from '../../../../common/button-arrow';

const NavigationLinkItem = ({item, ...props}) => (
  <Panel className="product-item">
    <Row>
      <Col md={8} style={{userSelect: 'none'}}>
        {item.attributes.name}
      </Col>
      <Col md={4}>
        <ArrowButton
          arrow={false}
          className="pull-right"
          onClick={() => props.onDelete(item.id)}
          permissions={{
            action: 'remove',
            subjectClass: 'NavigationLink'
          }}
          submit={false}
        >
          Delete
        </ArrowButton>
        <ArrowButton
          arrow={false}
          className="pull-right"
          color="grey"
          onClick={() => props.onEdit(item.id)}
          permissions={{
            action: 'edit',
            subjectClass: 'NavigationLink'
          }}
          submit={false}
        >
          Edit
        </ArrowButton>
      </Col>
    </Row>
  </Panel>
);

export default NavigationLinkItem;



// WEBPACK FOOTER //
// ./src/components/admin/navigation/links/list/navigation-link-item.jsx